<div class="card-heading">
  <h4 class="card-title" name="title">{{ heading() }}</h4>
  <div class="right">
    @if (description) {
      <i
        class="icon far fa-question-circle"
        name="description"
        arial-label="Chart Description"
        placement="bottom"
        container="body"
        tooltipClass="card-tooltip"
        [ngbTooltip]="description"
      ></i>
    }

    @if (showFavorites()) {
      <app-favorite-list
        [chart]="chart()"
        [favorites]="favorites()"
        [dashboards]="dashboards()"
        (addChartToDashboard)="onAddChartToDashboard($event)"
        (removeChartFromDashboard)="onRemoveChartFromDashboard($event)"
        (createDashboard)="onCreateDashboard($event)"
      />
    }

    <ng-content select="[actions]" />
  </div>
</div>
<div class="card-body">
  <ng-content />
</div>
